import ScrollToJumpLinksUtility from './scrollToJumpLinksUtility';

export default ScrollToJumpLinksUtility;
